import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { I18NextService } from 'angular-i18next';
import { ExportTasksFilterState } from '../../enums/export-tasks-filter.enum';
import { TaskState } from '../../enums/task-state.enum';
import { WorkflowArea } from '@modeso/aumico-lib-cpmm-fe/enums/workflow-area.enum';

@Component({
    selector: 'export-tasks-filter-dropdown',
    templateUrl: './export-tasks-filter-dropdown.component.html',
    styleUrls: ['./export-tasks-filter-dropdown.component.scss'],
})
export class ExportTasksFilterDropDown {
    @Input() selectedStatus: (TaskState | ExportTasksFilterState)[] = [];
    @Input() area: WorkflowArea;
    @Output() exportExcelClicked = new EventEmitter<(TaskState | ExportTasksFilterState)[]>();

    public openedFlyout = false;

    public flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    public taskOptions = [
        { label: 'Open', value: TaskState.OPEN, icon: 'assets/hamIcons/clipboard-list-outline.svg' },
        { label: 'In Progress', value: TaskState.IN_PROGRESS, icon: 'assets/hamIcons/clipboard-list-outline.svg' },
        { label: 'In Review', value: TaskState.IN_REVIEW, icon: 'assets/hamIcons/clipboard-list-outline.svg' },
        { label: 'N/A', value: TaskState.NOT_APPLICABLE, icon: 'assets/hamIcons/clipboard-check-outline.svg' },
        { label: 'Completed', value: TaskState.DONE, icon: 'assets/hamIcons/archive-outline.svg' },
    ];

    public includeAnnotationsOption = {
        label: 'Annotaitons',
        value: ExportTasksFilterState.INCLUDE_ANNOTATION,
        icon: 'assets/hamIcons/message-caption-outline.svg',
    };
    public includeDocumentsOption = {
        label: 'Documents',
        value: ExportTasksFilterState.INCLUDE_DOCUMENTS_NAMES,
        icon: 'assets/hamIcons/file-lines-outline.svg',
    };

    constructor(private readonly localizedTexts: I18NextService) {
        this.taskOptions[0].label = this.localizedTexts.t('aumico_reports_cpmm_export_tasks_open_tasks') as string;
        this.taskOptions[1].label = this.localizedTexts.t(
            'aumico_reports_cpmm_export_tasks_in_progress_tasks',
        ) as string;
        this.taskOptions[2].label = this.localizedTexts.t('aumico_reports_cpmm_export_tasks_in_review_tasks') as string;
        this.taskOptions[3].label = this.localizedTexts.t('aumico_reports_cpmm_export_tasks_na_tasks') as string;
        this.taskOptions[4].label = this.localizedTexts.t('aumico_reports_cpmm_export_tasks_completed_tasks') as string;
        this.includeAnnotationsOption.label = this.localizedTexts.t(
            'aumico_reports_cpmm_export_tasks_include_annotations',
        ) as string;
        this.includeDocumentsOption.label = this.localizedTexts.t(
            'aumico_reports_cpmm_export_tasks_include_documents_names',
        ) as string;
    }
    ngOnInit(): void {
        if (this.area === WorkflowArea.CLOSING_PROCESS) {
            this.taskOptions.splice(1, 2);
        }
        else {
            this.selectedStatus.push(ExportTasksFilterState.INCLUDE_DUEDATES);
        }
    }

    onStatusSelection(value: TaskState | ExportTasksFilterState, checked: boolean) {
        if (checked) {
            this.selectedStatus.push(value);
        } else {
            this.selectedStatus = this.selectedStatus.filter((v) => v !== value);
        }
    }

    openFlyout(buttonComponent: HamButtonComponent): void {
        const buttonElement = buttonComponent.nativeButton?.nativeElement;

        if (!buttonElement) return;

        const rect = buttonElement.getBoundingClientRect();

        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: rect.left - 180,
        };

        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    exportExcel(): void {
        this.exportExcelClicked.emit(this.selectedStatus);
    }
}
